<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild">
      <div class="header-top-side">
        <div class="pc-container">
          <i class="left"></i><em></em><i class="right"></i>
          <span class="circle"></span>
        </div>
      </div>
      <div class="header-bottom-side">
        <div class="header-bottom-background"></div>
        <!-- 导航 -->
        <div class="header-nav pc-container">
          <!-- 导航内容 -->
          <ul class="header-nav-wrapper">
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="index == navIndex ? 'active' : ''"
              @click="navClick(index, item.name)"
            >
              <router-link :to="item.path">
                {{ item.name }}
                <span
                  v-if="item.children.length > 0"
                  class="glyphicon glyphicon-menu-down"
                ></span>
                <i class="underline"></i>
              </router-link>
              <dl v-if="item.children.length > 0">
                <dt v-for="(i, n) in item.children" :key="n">
                  <router-link :to="i.path">{{ i.name }}</router-link>
                </dt>
              </dl>
            </li>
            <li class="top-search-box">
              <div class="search-box-button">
                <i></i>
                <!-- <input type="text" placeholder="请输入搜索内容" v-model="searchText" />  -->
                <el-input placeholder="请输入内容" v-model="searchText" clearable style="boder:0;">
                </el-input>
                <img
                  src="../assets/img/close.png"
                  alt=""
                  class="close"
                  @click="close()"
                  v-if="closeShow"
                />
                <a @click="openPage()">搜索</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "文化资讯",
          path: "/newsO",
          children: [],
        },
        {
          name: "享活动",
          path: "/activityO",
          children: [],
        },
        {
          name: "订场馆",
          path: "/venueO",
          children: [],
        },
        {
          name: "学才艺",
          path: "/newsTh",
          children: [],
        },
        {
          name: "看直播",
          path: "/classroomO",
          children: [],
        },
        {
          name: "非遗保护",
          path: "/newsT",
          children: [],
        },
        {
          name: "文化配送",
          path: "/classroomT",
          children: [],
        },
        {
          name: "赶大集",
          path: "/activityT",
          children: [],
        },
        {
          name: "特色文化",
          path: "/classroomTh",
          children: [],
        },  
        {
          name: "精品共享",
          path: "/venueT",
          children: [],
        },                    
        {
          name: "辅助创作",
          path: "/creation",
          children: [],
        },                    
      ],
      searchText: "", //搜索内容
      closeShow: false, //清除搜索
    };
  },
  created() {
    this.navIndex = window.sessionStorage.getItem("navIndex")
      ? sessionStorage.getItem("navIndex")
      : 0;
    sessionStorage.setItem("navIndex", this.navIndex);
  },
  mounted() {},
  watch: {
    "$store.state.navIndex"(val) {
      this.navIndex = val;
    },
  },
  methods: {
    // focus(){
    //     this.closeShow = false
    // },
    // blur(){
    //   if( this.searchText != ""){
    //      this.closeShow = true
    //   }

    // },
    close() {
      this.searchText = "";
      this.closeShow = false;
    },
    openPage() {
      this.$router.push({
        name: "search",
        query: {
          searchText: this.searchText,
          entid: this.$route.query.entid,
        },
      });
      this.navIndex = 0;
      window.sessionStorage.setItem("navIndex", 0);
      this.searchText = "";
    },
    //切换tab
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    //菜单
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
  },
};
</script>
<style scoped>
/* 顶部 */
#header {
  transition: all ease 0.6s;
  position: relative;
  z-index: 101;
}
#header .header-top {
  height: 206px;
  color: #fff;
}
.header-top-side {
  height: 103px;
  background: #B34F2C;
  border-bottom: 1px solid #fff;
  text-align: center;
  font-size: 18px;
  position: relative;
}
.header-top-side i {
  display: inline-block;
  width: 415px;
  height: 1px;
  margin: 0 29px;
  margin-top: 69px;
  vertical-align: top;
  background: linear-gradient(355deg, #fff 0%, #fff0 100%);
}
.header-top-side .right {
  background: linear-gradient(5deg, #fff 0%, #fff0 100%);
}
.header-top-side em {
  display: inline-block;
  width: 250px;
  height: 47px;
  background: url("../assets/img/logo.png") no-repeat;
  background-size: 100%;
  margin-top: 38px;
}
.header-bottom-side {
  position: relative;
}
.header-top-side .circle {
  display: inline-block;
  width: 309px;
  height: 38px;
  background: url("../assets/img/topbg1.png") no-repeat;
  background-size: 100%;
  position: absolute;
  top: 102px;
  left: 50%;
  margin-left: -154.5px;
}
.header-bottom-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 103px;
  background: #B34F2C;
  opacity: 0.44;
}

/* 导航栏 */
#header .header-nav {
  padding-top: 46px;
  width:100%;
}
.header-nav-wrapper {
  display: flex;
  align-content: center;
  justify-content: center;
  width: 100%;
}
#header .header-nav .header-nav-wrapper > li {
  margin: 0 1%;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -10px;
  left: 50%;
  width: 0;
  height: 10px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #fff;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #fff;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #fff;
  text-decoration: none;
  border-bottom: 10px solid #fff;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 10px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
.search-box-button {
  width: 271px;
  height: 40px;
  border-radius: 24px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-box-button i {
  display: inline-block;
  width: 15px;
  height: 15px;
  background: url("../assets/img/search.png") no-repeat;
  background-size: 100%;
  margin-right: 10px;
  margin-left: 10px;
}
.search-box-button input {
  outline: 0;
  border: 0;
  color: #333;
  width: 140px;
}
.search-box-button .close {
  width: 20px;
  height: 20px;
}
.search-box-button a {
  display: inline-block;
  width: 53px;
  height: 30px;
  border-radius: 24px;
  background: #B34F2C;
  color: #fff;
  font-size: 17px;
  text-align: center;
  line-height: 30px;
  margin: 5px 0 5px 10px;
}
.search-box-button a:hover {
  text-decoration: none;
}
/deep/ .el-input {
  width: 60%;
}
.el-input--suffix /deep/ .el-input__inner{
  border: 0;
 
}
@media (max-width:1400px){
  #header .header-nav .header-nav-wrapper > li {
    margin: 0 10px;
  }
  #header .header-nav .header-nav-wrapper > li > a {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue